import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthStateService } from '../../shared/services/auth-state.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authState: AuthStateService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const authToken = this.authState.token;
    const isSsoSession = sessionStorage?.getItem('ssoSession') === '1';

    if (authToken && authToken.length > 0 && !req.url.includes('login')) {
      req = req.clone({
        setHeaders: {
          'X-Auth-Token': authToken,
        },
      });
    } else if (isSsoSession) {
      req = req.clone({ withCredentials: true });
    }

    return next.handle(req);
  }
}
